exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-content{display:flex;justify-content:center;align-items:flex-start;font-size:14px;line-height:32px;padding-left:40px}.about-content a{color:#75b325}.about-content a:hover{color:#60921e;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d134fc8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shell/components/AboutDialog.vue
// module id = 268
// module chunks = 0